import type { FC } from 'react';
import { Flex } from 'antd';
import { CalendarIcon } from '@/assets/icons/icons';
import { usePickupPrefill } from '@/hooks/useFedExPickup';
import { useFedExPickupGate } from '@/hooks/useFedExPickupGate';
import { isPickupStatusBlocked } from '@/pages/Shipments/components/FedExPickupControls';
import { canSchedulePickupFromPrefill } from '@/pages/Shipments/components/fedexPickupUtils';
import type { ShipmentRow } from '../../types';

const isFedExRow = (row: ShipmentRow) =>
  /^fedex\b/i.test((row.courier_name ?? '').trim());

const canOfferForRow = (row: ShipmentRow) =>
  isFedExRow(row) &&
  row.leg_type !== 'EL' &&
  !row.actual_pickup_date &&
  !isPickupStatusBlocked(row.status);

interface SchedulePickupMenuItemProps {
  shipment: ShipmentRow;
  onSelect: () => void;
}

const EligibleMenuItem: FC<SchedulePickupMenuItemProps> = ({
  shipment,
  onSelect,
}) => {
  const gateOn = useFedExPickupGate();
  const { prefill } = usePickupPrefill(
    shipment.id ?? shipment.shipment_id,
    gateOn
  );

  if (!gateOn || !canSchedulePickupFromPrefill(prefill)) return null;

  return (
    <Flex
      align='center'
      className='header-menu-item'
      onClick={(event) => {
        event.stopPropagation();
        onSelect();
      }}
    >
      <CalendarIcon width={12} height={12} />
      <span className='header-menu-item-content'>Schedule pickup</span>
    </Flex>
  );
};

/** Mounts with the row menu, so prefill is fetched on first open rather than per row. */
const SchedulePickupMenuItem: FC<SchedulePickupMenuItemProps> = (props) =>
  canOfferForRow(props.shipment) ? <EligibleMenuItem {...props} /> : null;

export default SchedulePickupMenuItem;
